import { v4 as uuidv4 } from 'uuid';
import classNames from 'classnames';
import {useTranslation} from "react-i18next";
import React, {useState} from "react";

export default function Categories({categories, notifyChange, current, reset}) {
    const { t } = useTranslation();
    const [showCategories, setShowCategories] = useState(false);

    return (
        <>
            { showCategories && <div className="overlay is-visible" onClick={() => {
                setShowCategories(false);
            }} />}
            { !!categories.length &&
            <button
                onClick={() => {
                    setShowCategories(!showCategories);
                }}
                className={classNames("btn btn-show-categories", {"close-btn": showCategories})}>
                <span>{t('surveys.categories')}</span>
                <div />
            </button>
            }
            <form className="js-categories-form">
                <div className={classNames('survey-categories flex wrap-flex', {"open": showCategories})}>
                    {
                        categories.map(category =>
                            <div onClick={() => {
                                setShowCategories(false);
                                if (current === category.id) {
                                    reset();
                                } else {
                                    notifyChange(category.id);
                                }
                            }} key={uuidv4()}>
                                <input defaultChecked={current === category.id} type="radio" name="categories" value={category.id}
                                       id={"category-" + category.id} className="checkbox"/>
                                <label htmlFor={"category-" + category.id}>{category.name}</label>
                            </div>
                        )
                    }
                </div>
            </form>
        </>

    )
}
